"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDictList = void 0;
var _axios = _interopRequireDefault(require("@/utils/axios"));
/**
 * 字典查询接口
 * @param {object} params
 * @param {string} params.code 字典码
 * @returns {Promise<{
 *   id: string;
 *   parentId: string;
 *   code: string;
 *   dictKey: string;
 *   dictValue: string;
 *   sort: number;
 *   remark: string;
 * }[]>} **data**
 *    - id: ID;
 *    - parentId: 父ID;
 *    - code: 字典码;
 *    - dictKey: 字典值;
 *    - dictValue: 字典名称;
 *    - sort: 排序;
 *    - remark: 字典备注;
 */
const getDictList = params => _axios.default.get('/dict/dictionary', {
  params
});
exports.getDictList = getDictList;